export const MOCKUP_SWAG_BUNDLE_NOTECARD_HIDDEN_CONTAINER_ID = 'mockup-swag-bundle-notecard-hidden-container';